import { shallowCopy } from './utility';

/*
 * 一覧画面の検索条件の管理
 *
 *  検索ボタンクリック → 画面の検索条件欄に入力されている値で検索
 *  ソート順・ページング・CSV出力等 → 表示されている値ではなく、直前の検索ボタンクリック時の値で検索
 * を実現するため、画面表示用の値と、実際の検索条件に使う用の値を別に管理する
 */
export class SearchConditionInputBuffer<PARAMS> {
    displayParam: PARAMS;
    private searchParam: PARAMS;

    // vue 3 のcomposition apiがあれば、SortParamとPagingParamと一連の処理をまとめられるかもしれない

    /**
     * コンストラクタ
     * @param {PARAMS} initialValue 初期値
     */
    constructor(initialValue: PARAMS) {
        this.searchParam = shallowCopy(initialValue);
        this.displayParam = shallowCopy(initialValue);
    }

    /**
     * 検索処理で使う条件を取得する 画面に入力されている値とは異なる場合がある
     * @returns {Readonly<PARAMS>}
     */
    currentSearchParam(): Readonly<PARAMS> {
        return this.searchParam;
    }

    /**
     * 画面に入力されている値を、検索条件に反映する
     */
    searchConditionChange() {
        this.searchParam = shallowCopy(this.displayParam);
    }
}
